import {h, Component, Fragment} from "preact";
import {route} from "preact-router";
import {TicketHeader, TicketBody, EndedTicketPopups} from "../mobile-pages/ticket-ltn.jsx";
import Page from "../../../services/page-data-feed";
import LFeed from "../../../services/live-feed";
import Ticket from "../utils/ticket-logic.jsx";

import FullSite from "./full-site";

import * as M from "../desktop-templates/prematch-menu.jsx";
import * as L from "../desktop-templates/live-general.jsx";
import * as T from "../desktop-templates/prematch-right-col.jsx";
import * as P from "../mobile-templates/sports.jsx";
import * as I from "../utils/icons.jsx";
import * as E from "../desktop-templates/prematch-single-event.jsx";

import LiveMenuSide from "../desktop-components/live-menu-side.jsx";
import LiveEventContent, {LiveTrackerByEventPanel} from "../desktop-components/live-event.jsx";

import TicketCheckBet from "../desktop-components/ticket-check-bet.jsx";
import TicketLoadBet from "../desktop-components/ticket-load-bet.jsx";
import TicketFastBet from "../desktop-components/ticket-fast-bet.jsx";
import Observer from "../utils/observer";

const USE_BIG_TRACKER = false;

export default class LiveEventClass extends Component {
	state = {
		event: null,
		// useSmallTracker: false
	}

	componentWillMount() {
		LFeed.onUpdate(this.handle = () => {
			this.setState({event: LFeed.getEvent('/event/'+this.props.eventId)});
		});

		// Observer.subscribe('live-tracker-toggle', () => this.setState({useSmallTracker: !this.state.useSmallTracker}));
	}

	componentDidUnmount() {
		LFeed.stopUpdate(this.handle);
	}

	render({eventId}) {
		return <FullSite>
			<div class="font-roboto">
				<div class="flex border-b border-b-zinc-950 bg-blue-whale-900 text-white p-3 gap-3">
				  <div class="w-72 flex-none rounded-lg overflow-hidden">
					<LiveMenuSide />
				  </div>
				  <div class="min-w-0 grow rounded-lg overflow-hidden">
					<LiveEventContent key={eventId} eventId={eventId} />
				  </div>
				  <div class="w-72 flex-none rounded-lg">
					{!USE_BIG_TRACKER && !!this.state.event? <LiveTrackerByEventPanel event={this.state.event} toggleTrackerType={() => Observer.notify('live-tracker-toggle')} /> : ''}
					<T.ColumnTicketWrappper>
						<T.TicketTopRow>
							<TicketHeader />
						</T.TicketTopRow>
						<TicketBody />
						<EndedTicketPopups />
					</T.ColumnTicketWrappper>
					<M.BlankSeparator />
					<TicketLoadBet />
					<M.BlankSeparator />
					<TicketCheckBet />
				  </div>
				</div>
			</div>
		</FullSite>;
	}
}

export function LiveEvent({eventId}) {
	return <FullSite>
		<div class="font-roboto">
			{false && <L.TopRowContainer>
			  <L.ContainerLink>
				<L.TopPageLink href="/prematch">sport home</L.TopPageLink>
				<L.TopPageLink href="/live/general">general view</L.TopPageLink>
				<L.TopPageLink active={true}>event view</L.TopPageLink>
			  </L.ContainerLink>
			</L.TopRowContainer>}
			<div class="flex border-b border-b-zinc-950 bg-blue-whale-900 text-white p-3 gap-3">
			  <div class="w-72 flex-none rounded-lg overflow-hidden">
				<LiveMenuSide />
			  </div>
			  <div class="min-w-0 grow rounded-lg overflow-hidden">
			    <LiveEventContent key={eventId} eventId={eventId} />
			  </div>
			  <div class="w-72 flex-none rounded-lg">
				<T.ColumnTicketWrappper>
					<T.TicketTopRow>
						<TicketHeader />
					</T.TicketTopRow>
					<TicketBody />
					<EndedTicketPopups />
				</T.ColumnTicketWrappper>
				<M.BlankSeparator />
				<TicketLoadBet />
				<M.BlankSeparator />
				<TicketCheckBet />
			  </div>
			</div>
		</div>
	</FullSite>
}

export class FirstLiveEvent extends Component {
	componentWillMount() {
		LFeed.onUpdate(this.handle = () => {
			this.redirectFirstEvent({})
		})
	}
	componentDidUnmount() {
		LFeed.stopUpdate(this.handle);
	}
	redirectFirstEvent() {
		if (!LFeed.menu) {
			return;
		}
		const sport = (LFeed.menu['/sport/'+this.props.sportId] || Object.values(LFeed.menu).sort((a, b) => a.order - b.order)[0]).sub;
		const tournament = Object.values(sport).sort((a, b) => a.order - b.order)[0].sub;
		const event = Object.values(tournament)[0];
		route('/live'+event.id, true);
		LFeed.stopUpdate(this.handle);
	}
	render({sportId}) {
		return <LiveEvent />
	}
}